import axios from "axios";

export const OK = 200
export const CREATED = 201
export const INTERNAL_SERVER_ERROR = 500
export const UNPROCESSABLE_ENTITY = 422
export const UNAUTHORIZED = 401
export const FORBIDDEN = 403
export const NOTFOUND = 404
export const CSRF_ERROR = 419

export async function sendParallelApi(apis) {
    let requestList = [];
    apis.forEach(function(api){
        switch(api.method){
            case 'post':
                requestList.push(axios.post(api.url, api.params)
                    .then(response =>{
                        api.callback(response);
                    }));
                break;
            case 'put':
                requestList.push(axios.put(api.url, api.params)
                    .then(response =>{
                        api.callback(response);
                    }));
                break;
            case 'delete':
                requestList.push(axios.delete(api.url, {params: api.params})
                    .then(response =>{
                        api.callback(response);
                    }));
                break;
           default:
                requestList.push(axios.get(api.url, {params: api.params})
                    .then(response =>{
                        api.callback(response);
                    }));
                break;
        }
    })
    await Promise.all(requestList);
}
